import { useMutation } from '@vue/apollo-composable';
import { ADD_MODULE_ELECTIVES, REMOVE_MODULE_ELECTIVE } from '@/graphql/mutations/moduleElectiveOfferings';
import type { AddModuleElectivesMutation, AddModuleElectivesMutationVariables, RemoveModuleElectiveMutation, RemoveModuleElectiveMutationVariables } from '@/types/operations';

export function useModuleElectiveMutations() {
  const { mutate: add, loading: adding } = useMutation<AddModuleElectivesMutation, AddModuleElectivesMutationVariables>(ADD_MODULE_ELECTIVES);
  const { mutate: remove, loading: removing } = useMutation<RemoveModuleElectiveMutation, RemoveModuleElectiveMutationVariables>(REMOVE_MODULE_ELECTIVE);
  return { add, remove, adding, removing };
}
